import { BSpinner, BText, BTitle } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { connect, ConnectedProps } from 'react-redux'
import { push } from 'connected-react-router'
import React, { useCallback, useEffect, Fragment } from 'react'

import { analyticsActions, modalDialogActions, popActions, scoringActions } from '../../redux'
import { API_ERROR } from '../../constants/modals'
import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'
import { Notification } from '../../components'
import { POOLING_DELAY_CLIENT_CHECK } from '../../constants'
import { Response } from '../../api/api'
import messages from '../../i18n'
import Routes from '../../constants/routes'

type Props = IntlInterface & WizardInterface & ConnectedProps<typeof connector>

export const PostProcessing = ({
  postStatusPoll,
  push,
  setAnalyticsPage,
  setDenialReason,
  showModalDialog,
  translate,
  wizard,
}: Props) => {
  const startPolling = useCallback(() => {
    postStatusPoll({
      success: wizard.gotoNext,
      error: (reasons: { denialReason: string; type: Response }) => {
        if (reasons.denialReason) {
          setDenialReason(reasons.denialReason)
          setAnalyticsPage(Routes.KO_SCORING)
          push(Routes.KO_SCORING)
        }
        if (reasons.type === Response.serverErrorRetry) {
          showModalDialog(API_ERROR({ errorInfo: { type: reasons.type }, onRetry: startPolling }))
        }
      },
    })
  }, [postStatusPoll, push, setAnalyticsPage, setDenialReason, showModalDialog, wizard.gotoNext])

  useEffect(() => {
    setTimeout(startPolling, POOLING_DELAY_CLIENT_CHECK)
  }, [startPolling])

  return (
    <Fragment>
      <BTitle center type="h3">
        {translate(messages.postProcessing.title)}
      </BTitle>
      <BText center type="secondary">
        {translate(messages.postProcessing.text)}
      </BText>
      <BSpinner isShown isStatic style={{ zIndex: 0 }} />
      <Notification description={translate(messages.postProcessing.notification)} type="success" />
    </Fragment>
  )
}

const connector = connect(null, {
  postStatusPoll: popActions.postStatusPoll,
  push,
  setAnalyticsPage: analyticsActions.setAnalyticsPage,
  setDenialReason: scoringActions.setDenialReason,
  showModalDialog: modalDialogActions.showModalDialog,
})

export default compose(intl, wizard, connector)(PostProcessing)
